import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { logEvent } from '../utils/logger';

export const useRouteChangeLogging = () => {
  const history = useHistory();

  useEffect(() => {
    const unlisten = history.listen((location) => {
      logEvent({
        event: 'route_change',
        pathname: location.pathname,
        search: location.search,
        hash: location.hash
      });
    });

    return unlisten;
  }, [history]);
};
